import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import { getRecords, saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData, basicFormData } from "./BranchFile.js";
import { validate } from "../../../custom/validations/Validate.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import formatDateTime from "../../../custom/Utils/formatDateTime.js";

const BranchView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {

    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>
                            Branch Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Branch Name: </strong>
                                {formData?.inputData?.branch_name || "-"}
                              </p>
                              <p>
                                <strong>City: </strong>
                                {formData?.inputData?.city?.city_name || "-"}
                              </p>
                              <p>
                                <strong>State: </strong>
                                {formData?.inputData?.state?.state_name || "-"}
                              </p>
                              <p>
                                <strong>Country: </strong>
                                {formData?.inputData?.country?.country_name || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                            
                              

                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active === true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                              <p>
                                <strong>Created At: </strong>
                                {formData?.inputData?.createdAt === null ? "NA" : formatDateTime(formData?.inputData?.createdAt)}
                              </p>

                              <p>
                                <strong>Updated At: </strong>
                                {formData?.inputData?.updatedAt === null ? "NA" : formatDateTime(formData?.inputData?.updatedAt)}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BranchView;
